import { PieArc as MuiPieArc, type PieArcProps } from '@mui/x-charts';
import { statusConfigs } from '@/views/Home/hooks/useFactsAndFigures';

export function PieArc(props: PieArcProps) {
  const { color, seriesId } = props;
  const statusLabel = Object.values(statusConfigs).find(
    (config) => config.color === color,
  )?.label;

  return <MuiPieArc data-testid={`${seriesId}-${statusLabel}`} {...props} />;
}
